import { Injectable } from "@angular/core";
import { LocalStorageService } from "./local-storage.service";
import { Select, Store } from "@ngxs/store";
import { GetYearList } from "../ngxs/years/years.actions";
import { GetYearListRequestState } from "../ngxs/years/years.state";
import { Observable } from "rxjs";
import { IRequest } from "ngxs-requests-plugin";
import { YearsGetterState } from "../ngxs/years/years-getter.state";

@Injectable({
  providedIn: 'root'
})
export class YearsService {
  @Select(GetYearListRequestState)
  getYearListRequestState$: Observable<IRequest>;

  @Select(YearsGetterState.getYearsList)
  yearList$: Observable<number[]>;

  constructor(
    private localStorageService: LocalStorageService,
    private store: Store,
  ) {}

  getYearList() {
    this.store.dispatch(new GetYearList());
  }

  getYearListSnapshot() {
    return this.store.selectSnapshot(YearsGetterState.getYearsList);
  }
}